<template>
    <AppLayoutBase>
        <template slot="drawer">

        </template>

        <template slot="main">
            <UserProfileContent/>
        </template>
    </AppLayoutBase>
</template>

<script>
    export default {
        name: ""
    }
</script>

<style scoped>

</style>